<nb-modal-header [title]="title" (close)="dismissModal()"></nb-modal-header>
<nb-modal-body>
  <div class="alert-content d-flex flex-row align-items-center justify-content-start">
    <span class="alert-icon" [ngStyle]="alertIconClass" [innerHTML]="icon"></span>
    <p class="alert-text" [innerHTML]="description"></p>
  </div>
</nb-modal-body>
<nb-modal-footer>
  <button *ngIf="mode === 'confirm'" class="btn btn-link" (click)="dismissModal()">
    {{ 'common:components.modal.cancel_btn' | i18n }}
  </button>
  <button *ngIf="mode === 'confirm'" class="btn btn-primary" (click)="closeModal()">
    {{ 'common:components.modal.confirm_btn' | i18n }}
  </button>
  <button *ngIf="mode !== 'confirm'" class="btn btn-primary" (click)="closeModal()">
    {{ 'common:components.modal.close_btn' | i18n }}
  </button>
</nb-modal-footer>
